module.exports = __webpack_public_path__ + "img/benefit.d9d3272f.jpg";